<template>
  <div>
    <div class="invoice-flow__logo-wrapper">
      <div class="method-options-card-header__icon" :style="logoStyles" />

      <div>{{ $t(method.name) }}</div>

      <template v-if="flow !== SelcomFlowType.UssdPush">
        <div class="accent bold">
          {{ $t('please_pay_attention') }}
        </div>
        <div class="accent bold">
          {{ $t('new_deposit_instructions') }}
        </div>
      </template>
    </div>

    <div v-if="flow === SelcomFlowType.UssdPush" class="ussd_message">
      {{ $t('invoice_flow__selcom_ussd_push_message') }}
    </div>

    <div v-else class="helper">
      <ol type="1">
        <li
          v-for="(step, index) in method.steps"
          :key="index"
          :class="method.accent.includes(index) ? 'accent' : ''"
        >
          {{ $t('invoice_flow__step', { index: index + 1 }) }}
          {{ $t(step, traslationOptions) }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mobileOperators from './data/mobileOperators';
import selcom_logo from './assets/selcom.png';

const SelcomFlowType = {
  UssdPush: 'ussd_push',
  UssdDynamic: 'ussd_dynamic',
  UssdStatic: 'ussd_static',
};

export default {
  data() {
    return {
      mobileOperators,
      SelcomFlowType,
    };
  },

  computed: {
    ...mapState(['flowData']),

    /*
     * @getter data
     * @returns {
     *     amount: string,
     *     business_number: string,
     *     id: string,
     *     phone: string,
     *     method: {
     *       code: string,
     *       logo: string (can be empty),
     *     }
     *  } | {}
     * */
    data() {
      return this.flowData.payload;
    },

    traslationOptions() {
      const { business_number, id: reference_number, amount } = this.data;

      return {
        business_number,
        reference_number,
        amount,
      };
    },

    flow() {
      return this.data.flow;
    },

    method() {
      const { logo: method_logo, code } = this.data.method;
      const { logo, name, steps, accent } = mobileOperators.find(el => el.code === code) || {};

      return {
        logo: method_logo || logo || selcom_logo,
        name,
        steps,
        accent,
      };
    },

    logoStyles() {
      return {
        'min-height': '10em',
        width: '10em',
        'background-image': `url(${this.method.logo})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'contain',
        'margin-bottom': '20px',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.accent {
  color: #ff5252 !important;
  font-size: 1.5em;
}

.bold {
  font-weight: bold;
}

.ussd_message {
  padding-top: 25px;
}

.invoice-flow__logo-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2em;
  align-items: center;
}

.collapse {
  display: flex;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  transition: 0.4s;
  align-items: center;
  background: inherit;
  position: relative;

  .title {
    margin-left: 18px;
    color: inherit;
    font-style: inherit;
  }
}

.collapse:after {
  content: '\02795';
  position: absolute;
  right: 0;
}

.active:after {
  content: '\2796';
}

ol {
  text-align: left;
  padding: 0 0 0 18px;
  margin: 0 0 18px 0;
}

.helper {
  display: flex;
  justify-content: center;
}
</style>
